<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card class="mt-4">
        <v-card-title class="third white--text font-weight-bold">
          <span class="ml-2">Informations de l'instructeur</span>
          <v-spacer />
          <v-icon v-if="!editable && canUserPerformAction" size="28" color="white" class="justify-end" @click="editable = true">mdi-pencil</v-icon>
          <v-icon v-else-if="canUserPerformAction" size="28" color="white" class="justify-end" @click="editable = false">mdi-eye</v-icon>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="formValid">
            <v-row no-gutters>
              <v-col cols="4" class="mt-4 px-2">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Nom {{ editable ? ' *' : '' }}</v-list-item-subtitle>
                    <v-list-item-title v-if="!editable">{{ collaborator.lastname }}</v-list-item-title>
                    <v-list-item-title v-else>
                      <v-text-field
                        v-model="editableInstructor.lastname"
                        placeholder="Nom"
                        color="black"
                        :rules="mandatoryRule"
                      />
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="4" class="mt-4 px-2">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Prénom {{ editable ? ' *' : '' }}</v-list-item-subtitle>
                    <v-list-item-title v-if="!editable">{{ collaborator.firstname }}</v-list-item-title>
                    <v-list-item-title v-else>
                      <v-text-field
                        v-model="editableInstructor.firstname"
                        placeholder="Prénom"
                        color="black"
                        :rules="mandatoryRule"
                      />
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <!-- <v-col cols="4" class="mt-4 px-2">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Fonction {{ editable ? ' *' : '' }}</v-list-item-subtitle>
                    <v-list-item-title v-if="collaborator.instructor_roles && !editable">
                      <v-chip-group
                        column
                        multiple
                      >
                        <v-chip
                          v-for="role in getInstructorFunction"
                          :key="role"
                          color="third"
                          class="white--text font-weight-bold"
                        >
                          {{ role }}
                        </v-chip>
                        <v-tooltip v-if="showMoreButton(collaborator.instructor_roles, moreAmount)" color="white" right>
                          <template #activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              color="grey"
                              class="white--text font-weight-bold"
                              v-on="on"
                            >
                              voir plus
                            </v-chip>
                          </template>
                          <v-chip-group
                            column
                            multiple
                          >
                            <v-chip
                              v-for="role in collaborator.instructor_roles"
                              :key="role"
                              color="third"
                              class="white--text font-weight-bold"
                            >
                              {{ role }}
                            </v-chip>
                          </v-chip-group>
                        </v-tooltip>
                      </v-chip-group>
                    </v-list-item-title>
                    <v-list-item-title v-else-if="!editableInstructor.instructor_roles && !editable">--</v-list-item-title>
                    <v-list-item-title v-else>
                      <v-select
                        v-model="editableInstructor.instructor_roles"
                        item-value="value"
                        item-text="label"
                        dense
                        outlined
                        chips
                        multiple
                        class="ma-2"
                        :items="instructorFunctionsOptions"
                        :rules="mandatoryRule"
                        color="third"
                        item-color="third"
                      />
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col> -->
            </v-row>
            <v-row no-gutters>
              <v-col cols="4" class="px-2">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Mobile {{ editable ? ' *' : '' }}</v-list-item-subtitle>
                    <v-list-item-title v-if="collaborator.mobilephone && !editable">{{ collaborator.mobilephone }}</v-list-item-title>
                    <v-list-item-title v-else-if="!collaborator.mobilephone && !editable">--</v-list-item-title>
                    <v-list-item-title v-else>
                      <v-text-field
                        v-model="editableInstructor.mobilephone"
                        placeholder="Mobile"
                        color="black"
                      />
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="4" class="px-2">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Mail {{ editable ? ' *' : '' }}</v-list-item-subtitle>
                    <v-list-item-title v-if="collaborator.email && !editable">{{ collaborator.email }}</v-list-item-title>
                    <v-list-item-title v-else-if="!collaborator.email && !editable">--</v-list-item-title>
                    <v-list-item-title v-else>
                      <v-text-field
                        v-model="editableInstructor.email"
                        placeholder="Mail"
                        color="black"
                        :rules="emailRule"
                      />
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <!-- <v-col cols="4" class="px-2">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Diplôme {{ editable ? ' *' : '' }}</v-list-item-subtitle>
                    <v-list-item-title v-if="collaborator.instructor_diploma && !editable">
                      <v-chip-group
                        column
                        multiple
                      >
                        <v-chip
                          v-for="diploma in getInstructorDiploma"
                          :key="diploma"
                          color="third"
                          class="white--text font-weight-bold"
                        >
                          {{ diploma }}
                        </v-chip>
                        <v-tooltip v-if="showMoreButton(collaborator.instructor_diploma, moreAmount)" color="white" right>
                          <template #activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              color="grey"
                              class="white--text font-weight-bold"
                              v-on="on"
                            >
                              voir plus
                            </v-chip>
                          </template>
                          <v-chip-group
                            column
                            multiple
                          >
                            <v-chip
                              v-for="diploma in collaborator.instructor_diploma"
                              :key="diploma"
                              color="third"
                              class="white--text font-weight-bold"
                            >
                              {{ diploma }}
                            </v-chip>
                          </v-chip-group>
                        </v-tooltip>
                      </v-chip-group>
                    </v-list-item-title>
                    <v-list-item-title v-else-if="!editableInstructor.instructor_diploma && !editable">--</v-list-item-title>
                    <v-list-item-title v-else>
                      <v-select
                        v-model="editableInstructor.instructor_diploma"
                        item-value="value"
                        item-text="label"
                        dense
                        outlined
                        chips
                        hide-details
                        class="ma-2"
                        :items="instructorDiplomaOptions"
                        :rules="mandatoryRule"
                        color="third"
                        item-color="third"
                      />
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col> -->
              <!-- <v-col v-if="canShowQualificationField" cols="4" class="px-2">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Qualification</v-list-item-subtitle>
                    <v-list-item-title v-if="collaborator.instructor_qualification && !editable">{{ collaborator.instructor_qualification }}</v-list-item-title>
                    <v-list-item-title v-else-if="!collaborator.instructor_qualification && !editable">--</v-list-item-title>
                    <v-list-item-title v-else>
                      <v-text-field
                        v-model="editableInstructor.lastname"
                        placeholder="Qualification"
                        color="black"
                      />
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col> -->
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider v-if="editable" />
        <v-card-actions v-if="editable">
          <v-spacer />
          <Button
            :disabled="!formValid"
            label="Enregistrer"
            :action="saveCollaborator"
            icon="mdi-content-save"
          />
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import Button from '@/components/common/Button.vue';
import { sendNotification, mandatoryRule } from '@/helpers/utils';
import { updateCollaborator } from '@/helpers/request';

import store from '@/store';

export default {
  components: { Button },
  props: {
    collaborator: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  setup (props) {
    const instructors = computed(() => store.state.instructors);
    const editable = ref(false);
    const formValid = ref(false);
    const emailRule = computed(v => [!!v || 'Email is required', regex => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(regex) || 'E-mail must be valid']);

    const editableInstructor = ref({ ...props.collaborator });

    const origianlInstructor = ref({ ...props.collaborator });

    const saveCollaborator = async () => {
      // editableInstructor.value.fullname = `${editableInstructor.value.firstname} ${editableInstructor.value.lastname}`;
      const response = await updateCollaborator(editableInstructor.value);
      if (!response.success) {
        const text = 'Erreur d\'enregistrement de l\'instructeur';
        sendNotification('error', text);
        editableInstructor.value = { ...origianlInstructor.value, fullname: `${editableInstructor.value.firstname} ${editableInstructor.value.lastname}` };
        return;
      }
      response.data.fullname = `${editableInstructor.value.firstname} ${editableInstructor.value.lastname}`;

      // update instructor on instructor array on store
      const index = instructors.value.findIndex(i => i.uuid === editableInstructor.value.uuid);
      if (index !== -1) {
        const allInsctructors = [...instructors.value];

        allInsctructors[index] = {
          ...allInsctructors[index],
          ...response.data
        };

        store.commit('setInstructors', allInsctructors);
      }

      const text = 'Instructeur enregistré avec succès';
      sendNotification('success', text);
      editable.value = false;
    };

    const canUserPerformAction = computed(() => store.getters.canUserPerformAction);

    return { canUserPerformAction, editable, formValid, mandatoryRule, saveCollaborator, editableInstructor, emailRule };
  }
};
</script>
